import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../../utils/storeApp";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { Paginator } from "primereact/paginator";
import CallAPI from "../../../services/apiCalls";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import SearchMessageStatus from "./SearchMessageStatus";
import GuideMessageStatus from "./GuideMessageStatus";
import { useReactToPrint } from "react-to-print";
import { DownloadTableExcel } from "react-export-table-to-excel";

const ListMessageStatus = () => {
  const { userToken, userSession, SetSharedObject, sharedObject } =
    useUserStore((state) => ({
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      userSession: state.userSession,
    }));
  const navigate = useNavigate();
  const [rowCount, setRowCount] = useState(100);
  const [gridResults, setGridResults] = useState([]);
  const [processing, SetProcessing] = useState(false);
  const [fromAddress, setFromAddress] = useState([]);

  const getDefaultMessageStatus = async (email) => {
    SetProcessing(true);
    let call = "/users/GetMessageStatus";
    let d = new Date();
    d.setFullYear(d.getFullYear() - 5);
    let search = {
      RowCount: rowCount,
      OrganizationId: userSession.org_id,
      StartDate: d,
      EndDate: new Date(),
      MessageSource: "Sent",
      sortBy: "SentDate",
      sortDir: "SentDate",
      FromAddress: email,
    };
    const res = await CallAPI(call, search, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetSharedObject("previousSearch", search);
      SetSharedObject("messageStatusResultsFlag", false);
      getReport(1, res.data.data.pageItems);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  useEffect(() => {
    let obj = sharedObject.recievedMessageStatusResults;
    if (sharedObject.messageStatusResultsFlag) {
      if (obj && Object.keys(obj).length > 0) {
        getReport(1, obj);
      } else {
        setGridResults([]);
      }
    } else {
      getDirectEmails(userSession.sesuser_id);
      SetSharedObject("messageStatusResultsFlag", false);
    }
    return () => {
      SetSharedObject("messageStatusResultsFlag", false);
    };
  }, [sharedObject.recievedMessageStatusResults]);

  const getDirectEmails = async (id) => {
    SetProcessing(true);
    let call = "/emails/GetUserEmailsList";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      const obj = res.data.message.directEmails;
      setFromAddress(obj);
      getDefaultMessageStatus(obj[0].directEmailAddress);
    } else if (res.status == "SERVERERROR") {
      SetProcessing(false);
    }
  };

  const [first, setFirst] = useState(1);
  const [last, setLast] = useState(25);
  const [rows, setRows] = useState(25);
  const [count, setCount] = useState(0);
  const [refreshObj, SetRefreshObj] = useState(false);
  const onPageChange = (event) => {
    setFirst(event.first + 1);
    setRows(event.rows);
    let lastNr = event.first + 25;
    let last = lastNr > count ? count : lastNr;
    setLast(last);
    let page = event.page + 1;
    SetRefreshObj(sharedObject.messageStatusSearch);
  };

  const getReport = (page, search) => {
    for (var i = 0; i < search.length; i++) {
      if (search[i].isMDN === false) {
        search[i].messageType = "Not MDN";
      } else {
        search[i].messageType = "MDN";
      }
    }
    setGridResults(search);
  };

  const getSeverity = (product) => {
    switch (product.status) {
      case "Confirmed":
        return "success";
        break;
      case "Success":
        return "success";
        break;
      case "Accepted":
        return "success";
        break;
      case "Failed":
        return "danger";
        break;

      default:
        return null;
        break;
    }
  };
  const messageStatusTemplate = (product) => {
    let s = (
      <>
        <Tag value={product.status} severity={getSeverity(product)}></Tag>
      </>
    );
    return s;
  };
  const formatDateAccepted = (dt) => {
    if (dt.dateAccepted) {
      return new Date(dt.dateAccepted).toLocaleString();
    } else {
      return "";
    }
  };
  const formatDateConfirmed = (dt) => {
    if (dt.dateConfirmed) {
      return new Date(dt.dateConfirmed).toLocaleString();
    } else {
      return "";
    }
  };
  const formatExtendedStatus = (dt) => {
    if (dt.extendedStatus) {
      return new Date(dt.extendedStatus).toLocaleString();
    } else {
      return "";
    }
  };
  const formatSentDate = (dt) => {
    if (dt.dateSent) {
      return new Date(dt.dateSent).toLocaleString();
    } else {
      return "";
    }
  };
  const refreshPage = async () => {
    SetProcessing(true);
    setFirst(1);
    setLast(25);
    let refreshSearch = sharedObject.previousSearch;
    let call = "/users/GetMessageStatus";
    const res = await CallAPI(call, refreshSearch, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetSharedObject("previousSearch", refreshSearch);
      getReport(1, res.data.data.pageItems);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const setSelectAddress = (e) => {
    let selectedFromAddress = e.target.value;
    getDefaultMessageStatus(selectedFromAddress);
  };
  return (
    <div className="ListMessageStatus">
      <header>
        <div className="title-label">
          <i
            className="bi bi-send-check"
            aria-labelledby="Message Status Report"
            alt="Message Status Icon"
          ></i>
          <span className="spacer-margin2">Message Status</span>
        </div>

        <div className="mid-header-bar spacer-inline">
          <div className="spacer-inline spacer-margin6">
            <label>From:</label>
            <div className="spacer-inline">
              <select
                className="form-control shade-2"
                onChange={setSelectAddress}
              >
                {fromAddress?.map((address, index) => {
                  return (
                    <option key={index} value={address.directEmailAddress}>
                      {address.directEmailAddress}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <button
            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
            data-target="#MsgStatusSearchModal"
            data-toggle="modal"
            title="Search"
            alt="search for sent message"
          >
            <i className="bi bi-search" alt="search icon"></i>
          </button>
          {/*Reusable tools for reports*/}
          <DownloadTableExcel
            filename="SentMessageReport"
            sheet="Reports"
            currentTableRef={componentRef.current}
          >
            <button
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              title="File Download"
            >
              <i className="bi bi-download" alt="file download icon"></i>
            </button>
          </DownloadTableExcel>
          <button
            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
            title="Refresh Page"
            onClick={(e) => {
              if (gridResults?.length > 0) refreshPage();
            }}
          >
            <i className="bi bi-arrow-clockwise" alt="refresh page icon"></i>
          </button>
          <button
            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
            title="Print page"
            onClick={(e) => {
              if (gridResults?.length > 0) handlePrint();
            }}
          >
            <i className="bi bi-printer" alt="printer icon"></i>
          </button>
          {/*End*/}
          <button
            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
            data-target="#MsgGuideModal"
            data-toggle="modal"
            title="More information"
          >
            <i
              className="bi bi-chat-square-text"
              alt="More information icon"
            ></i>
          </button>
        </div>
      </header>
      <SearchMessageStatus />
      <GuideMessageStatus />

      <section className="grid-layout">
        {gridResults?.length > 0 ? (
          <div ref={componentRef}>
            <DataTable
              value={gridResults}
              rows={25}
              paginator
              selectionPageOnly
              rowsPerPageOptions={[25, 50, 75]}
              tableStyle={{ minWidth: "50rem" }}
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              dataKey="Id"
              columnResizeMode="expand"
              resizableColumns
              scrollable
              sortField="dateSent"
              sortOrder={-1}
            >
              <Column
                field="dateSent"
                body={formatSentDate}
                header="Sent Date"
                className="w-md8"
                sortable
              ></Column>
              <Column
                field="sentAddress"
                header="Sent To"
                className="truncate"
                sortable
              ></Column>
              <Column
                field="messageType"
                header="Message Type"
                className="w-md9"
                sortable
              ></Column>
              <Column
                field="status"
                header="Status"
                className="w-md4"
                body={messageStatusTemplate}
                sortable
              ></Column>
              <Column
                field="dateAccepted"
                body={formatDateAccepted}
                header="Date Time Accepted"
                className="w-md8"
                sortable
              ></Column>
              <Column
                field="dateConfirmed"
                body={formatDateConfirmed}
                header="Date Time Confirmed"
                className="w-md7"
                sortable
              ></Column>
              <Column
                field="extendedStatus"
                //body={formatExtendedStatus}
                header="Extended Status"
                className="word-set"
                sortable
              ></Column>
            </DataTable>
            {/* <Paginator first={first} rows={rows} totalRecords={count} onPageChange={onPageChange} />
                    <span className="">
                        {first} - {last} of {count}
                    </span> */}
          </div>
        ) : (
          <section className="empty-grid">
            There are currently no search results.
          </section>
        )}
      </section>
      {processing ? <div className="loading"></div> : null}
      {/*  ) : null}*/}
    </div>
  );
};

export default ListMessageStatus;
